export default "__VITE_ASSET__YiesOUm8__"